
import GridPattern from "../components/ui/GridPattern";
import { Cover } from "./ui/cover";
import { FlipWords } from "./ui/flipwords";
import { cn } from "../lib/utils";
import { IconArrowNarrowRight } from "@tabler/icons-react";
import AnimatedShinyText from "../components/ui/AnimatedShinyText";
function HeroSection() {
  const words = [" Sustainable", "Innovative", "Functional", "Recyclable"];
  return (
    <div className="App overflow-x-hidden">
      <GridPattern
        className="absolute inset-0 h-[100vh] "
        numSquares={20}
        x={0}
        y={0}
      />
      <div className="text-8xl font-bold h-[100vh] flex flex-col justify-center items-center">
        <div className="z-10 flex items-center justify-center">
          <div
            className={cn(
              "group rounded-full border border-black/5 bg-neutral-100 text-base text-white transition-all ease-in hover:cursor-pointer hover:bg-neutral-200 mb-8 "
            )}
          >
            <AnimatedShinyText className="inline-flex items-center justify-center px-4 py-1 transition ease-out hover:text-neutral-600 hover:duration-300 ">
              <span>✨ Material informatics services for</span>
              {/* <IconArrowNarrowRight className="ml-1 size-3 transition-transform duration-300 ease-in-out group-hover:translate-x-0.5" /> */}
            </AnimatedShinyText>
          </div>
        </div>
        <div className="flex-col justify-center items-center text-[#16423C]">
          {" "}
          <FlipWords words={words} />
          <div className=" text-[2.5rem] sm:text-[2.8rem] tracking-tighter md:text-7xl text-[#16423C] font-bold ">
            Product{" "}
            <span className="">
              Pack<Cover>ai</Cover>ging
            </span>
          </div>
        </div>
        <div className="text-lg text-center px-9 md:px-0 max-w-3xl tracking-tight md:tracking-normal md:text-xl text-[#16423C] font-medium mt-4 flex justify-center items-center md:max-w-4xl">
          Innovating packaging solutions for a sustainable future by leveraging
          AI to drastically reduce experimentation time and optimize materials.
          By integrating multiple modalities of data, we create eco-friendly
          designs that meet the needs of both consumers and the planet, ensuring
          efficient production and minimal waste.
        </div>
      </div>
    </div>
  );
}

export default HeroSection;
